/**
 * Main Script File
 */
window.jQuery = window.$ = require('jquery');
var processInclude = require('./util');
var slickSlider = require('./thirdParty/slickSlider');

$(document).ready(function () {
    processInclude(require('./customDropdown'));
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/countrySelector'));
    processInclude(require('./components/toolTip'));
    //
    processInclude(require('./components/header'));
    processInclude(require('./components/stickyFilter'));
    processInclude(require('./components/floatingLabel'));
    processInclude(require('./components/cookieNotification'));
    processInclude(require('./accessibility'));
    processInclude(require('./loqate'));
    processInclude(require('./productTile'));
    processInclude(require('./components/plpFaqAccordion'));
    processInclude(require('./components/segmentedControl'));
    processInclude(require('./components/plpFaqAccordion'));

    // Set up global accessibility for all slick carousels
    function setupAllCarousels() {
        var $carousels = $('.slick-initialized');
        // eslint-disable-next-line no-console
        console.log('Found ' + $carousels.length + ' slick carousels');
        $carousels.each(function () {
            slickSlider.setupAccessibility($(this));
        });
    }

    // Set up existing carousels after delays
    setTimeout(setupAllCarousels, 1000);
    setTimeout(setupAllCarousels, 2000);

    // Set up carousels after AJAX content loads
    $('body').on('product:afterAttributeSelect', function () {
        setTimeout(setupAllCarousels, 200);
    });
    $('body').on('cart:update', function () {
        setTimeout(setupAllCarousels, 200);
    });
    $('body').on('initRecommendationSlider', function () {
        setTimeout(setupAllCarousels, 200);
    });

    // Use MutationObserver to detect when new carousels are added
    var observer = new MutationObserver(function () {
        setTimeout(setupAllCarousels, 100);
    });

    // Observe the document body for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

require('./thirdParty/jquery.unveil.min');
require('brand_core/thirdParty/bootstrap');
require('base/components/spinner');
require('slick-carousel/slick/slick.js');
